


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import GenericSearch, { SearchItem } from '../Blocks/BookMeetingFlow/GenericSearch.vue';
import { SearchStore } from '@/store/searchstate';

@Component({ components: { GenericSearch } })
class QuickSearch extends Vue {
    @Prop() placeHolder!: string;
    @Prop() cssClass!: string;
    @Prop({ default: false }) hideAutoCompleter!: any;
    @Prop({ default: '' }) searchId!: string;
    @Prop({ default: false }) hideOnOutOfFocus!: boolean;

    public initialQuery: string = '';

    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            if (query) this.initialQuery = query;
        }
    }

    get mappedResults(): SearchItem[] {
        return SearchStore.searchResult
            .filter(x => x.name)
            .map((x, index) => ({
                id: index,
                description: x.name,
                ...x
            }));
    }

    public fetchResults(query: string) {
        SearchStore.saveSearchResult(query);
    }
    
    public clearDropdown() {
        SearchStore.saveSearchResult('');
    }
    public getSearchUrl(query: string = SearchStore.searchQuery) {
        return window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
    }

    public onSubmit(query: string) {
        window.location.href = this.getSearchUrl(query);
    }

    public onItemSelected(item: any) {
        if (item.showAll) {
            this.onSubmit(SearchStore.searchQuery);
        } else if (item.url) {
            window.open(item.url, item.target || '_self');
        }
    }
}

export default QuickSearch;
